import { submissionGroupActionTypes } from '@actions/actionTypes/submissionGroups';
import { submissionGroupInitialState, SubmissionGroupState } from './initialState/submissionGroups';
import { AnyAction } from 'redux';

export const submissionGroupReducer = (
  state = submissionGroupInitialState,
  action: AnyAction
): SubmissionGroupState => {
  switch (action.type) {
    case submissionGroupActionTypes.SET_SUBMISSION_GROUPS: {
      return { ...state, submissionGroups: action.payload };
    }
    case submissionGroupActionTypes.CREATE_GROUP_LOADING: {
      return { ...state, isCreating: action.payload };
    }
    case submissionGroupActionTypes.UPDATE_GROUP_LOADING: {
      return { ...state, isUpdating: action.payload };
    }
    case submissionGroupActionTypes.DELETE_GROUP_LOADING: {
      return { ...state, isDeleting: action.payload };
    }
    case submissionGroupActionTypes.SET_ALL_SUBMISSION_GROUPS: {
      return { ...state, submissionGroupsAll: action.payload };
    }
    default: {
      return state;
    }
  }
};
